enum ExportFormat {
    CSV = 'CSV',
    TXT = 'TXT',
    PDF = 'PDF',
    XLSX = 'XLSX',
    WORD = 'WORD'
}

export default ExportFormat;
